/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Modal, Button, Icon, Grid } from '@mairistem/composants';

const AssistantModalError = ({ isOpen, onClose }) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    size="tiny"
    closeIcon
    data-testid="assistant-modal-error"
  >
    <Modal.Header>Erreur lors de la création</Modal.Header>
    <Modal.Content
      // @ts-expect-error
      style={{
        textAlign: 'center',
      }}
    >
      <Grid>
        <Grid.Row style={{ alignItems: 'center' }}>
          <Grid.Column width={3}>
            <Icon size="massive" name="warning sign" />
          </Grid.Column>
          <Grid.Column width={13}>
            <p>
              Le recensé n’a pas été créé suite à une erreur lors du
              renseignement de ce dernier.
            </p>
            <p>Veuillez vérifier les données saisies.</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Modal.Content>
    <Modal.Actions>
      <Button data-testid="assistant-error-modal-close" onClick={onClose}>
        <Icon name="close" />
        Fermer
      </Button>
    </Modal.Actions>
  </Modal>
);

export default AssistantModalError;
